import { componentTransformerRegistry as UiComponentTransformerRegistry } from '@commerce-webcomponents/ui';
import { CMSDataType } from '../../utils/common';
import { AbstractComponentPropTypes } from '../registries';
import componentTransformerRegistry from '../registries/componentTransformerRegistry';
import { ComponentType } from '../registries/types/propTypes';

const transformComponent = <S extends AbstractComponentPropTypes>(data: CMSDataType, componentKey: string): S => {
  if (Object.hasOwn(componentTransformerRegistry, componentKey)) {
    return componentTransformerRegistry[componentKey](data) as S;
  } else if (Object.hasOwn(UiComponentTransformerRegistry, componentKey)) {
    return UiComponentTransformerRegistry[componentKey](data) as S;
  }
  return componentTransformerRegistry[ComponentType.default]({}) as S;
};

export default transformComponent;
